import { flux } from '@/core/flux.module';
import { StatisticsSummaryItem } from '@/summaryReport/summaryData.types';
import _ from 'lodash';
import { fetchStatsSummaryData } from '@/summaryReport/summaryReport.utilities';
import { ITEM_DATA_STATUS } from '@/trendData/trendData.constants';
import { setTrendItemColor } from '@/trendData/trend.actions';

export function setItems(items: StatisticsSummaryItem[]): void {
  flux.dispatch('SR_SET_ITEMS', { items });
}

export function addStatsSummary(item: StatisticsSummaryItem): void {
  fetchStatsSummaryData(item.id).then((result) => {
    const payload = {
      id: item.id,
      name: item.name,
      color: item.color,
      ...result,
    };
    flux.dispatch('SR_ADD_ITEM', payload);
    setTrendItemColor(payload.id, payload.color);
  });
}

export function insertStatsSummaryAtIndex(item: StatisticsSummaryItem, index: number): void {
  fetchStatsSummaryData(item.id).then((result) => {
    const payload = {
      id: item.id,
      name: item.name,
      color: item.color,
      ...result,
    };
    flux.dispatch('SR_INSERT_ITEM_AT', { item: payload, index });
    setTrendItemColor(payload.id, payload.color);
  });
}

export function removeItems(items: StatisticsSummaryItem[]): void {
  flux.dispatch('SR_REMOVE_ITEMS', { items });
}

export function setIsItemsOverlaid(isItemsOverlaid: boolean): void {
  flux.dispatch('SR_SET_IS_ITEMS_OVERLAID', { isItemsOverlaid });
}

export function setStatus(status: ITEM_DATA_STATUS): void {
  flux.dispatch('SR_SET_STATUS', { status });
}

export async function fetchStatsData(items: StatisticsSummaryItem[]): Promise<void> {
  setStatus(ITEM_DATA_STATUS.LOADING);
  await Promise.all(_.map(items, (item) => fetchStatsSummaryData(item.id).then((result) => ({ ...item, ...result }))))
    .then((updatedItems) => {
      setItems(updatedItems);
      setStatus(ITEM_DATA_STATUS.PRESENT);
    })
    .catch(() => setStatus(ITEM_DATA_STATUS.FAILURE));
}
